import APIController from '../core-api-controller';

export const fetchClientUsersApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/client_user/users${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const searchClientUsersApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/client_user/users/search_users${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const applyPromotionCodeApi = (id = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/client_user/products/${id}/apply_promotion_code`;
  return APIController.getApiCallback(path, paramsObj);
};
